<template>
  <span v-if="!edit" class="text-sm">
    {{ value ? "Sim" : "Não" }}
  </span>
  
  <CheckboxAnswer v-else v-bind="$attrs" no-label :question="original" class="w-full"/>
</template>

<script>

import CheckboxAnswer from '#views/questionnaire/answers/CheckboxAnswer';

export default {
  name: "CheckboxDetail",
  inheritAttrs: false,
  components: {
    CheckboxAnswer
  },
  props: {
    original: {
      type: Object,
      required: true,
    },
    value: {
      required: true,
    },
    edit: {
      type: Boolean,
      required: true,
    },
  },
  mounted(){
    this.$emit("update:modelValue", this.value);
  }
};
</script>
